import { useState, useCallback } from "react";
import { ImovelIPTU, GuiaIPTU, TipoGuia } from "@/types";
import {
  buscarImoveisPublicoRequest,
  buscarGuiasPublicoRequest,
  emitirGuiaPublicoRequest,
} from "@/app/portal/services/iptu";
import { useToast } from "@/contexts/ToastContext";

export const useIptuPublico = (handleReset: () => void) => {
  const [imoveis, setImoveis] = useState<ImovelIPTU[]>([]);
  const [guias, setGuias] = useState<GuiaIPTU[]>([]);
  const [loadingImoveis, setLoadingImoveis] = useState(false);
  const [loadingGuias, setLoadingGuias] = useState(false);
  const [loadingEmissao, setLoadingEmissao] = useState(false);
  const [erro, setErro] = useState<string | null>(null);
  const { showToast } = useToast()

  const buscarImoveis = async (cpfCnpj: string, recaptchaToken: string) => {
    setLoadingImoveis(true);
    try {
      const data = await buscarImoveisPublicoRequest({cpfCnpj, recaptchaToken});
      if (data.imoveis) {
        setImoveis(data.imoveis);
      }
      setLoadingImoveis(false);
    } catch (error: any) {
        if (error.status == 401) {
          handle401Error()
        }
        showToast({ content: "Erro ao buscar imóveis. Tente novamente mais tarde.", sticky: false, severity: 'error' })
      setLoadingImoveis(false);
    };
  }

  const buscarGuias = async (imovelId: string, tipoGuia: TipoGuia) => {
    setLoadingGuias(true);
    try {
      const data = await buscarGuiasPublicoRequest(imovelId, tipoGuia);
      setGuias(data);
      setLoadingGuias(false);
    } catch (error: any) {
      
      if (error?.status === 400) {
        setErro("Nenhuma guia foi encontrada para este imóvel");
      } 
      else if (error?.status === 401) {
        handle401Error()
      } else {
        showToast({ content: "Erro ao buscar guias. Tente novamente.", sticky: false, severity: 'error' })
      }
      setLoadingGuias(false);

    }
  };

  const EmitirGuia = useCallback(async (guiaId: string, imovelId: string) => {
    setLoadingEmissao(true);
    try {
      const novaAba = window.open('', '_blank');
      const { linkArquivo } = await emitirGuiaPublicoRequest(guiaId, imovelId);
      novaAba!.location.href = linkArquivo;

    } catch (error: any) {
      console.error("Erro ao emitir guia:", error);
      if (error?.status === 401) {
        handle401Error()
      } 
    } finally {
      setLoadingEmissao(false);
    }
  }, []);
  
  const handle401Error = () => {
    setErro("Você demorou um pouco. Tente novamente.");
    setLoadingImoveis(false)
    setLoadingGuias(false)
    setLoadingEmissao(false)
    setImoveis([])
    setGuias([])
    handleReset()
  }

  return {
    imoveis,
    guias,
    loadingImoveis,
    loadingGuias,
    loadingEmissao,
    erro,
    buscarImoveis,
    buscarGuias,
    EmitirGuia,
  };
};